import classNames from 'classnames';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
  viewRef?: any;
  style?: React.CSSProperties;
};

const ProductCardSkeleton = ({ className, viewRef, style = {} }: Props) => {
  return (
    <div ref={viewRef} className={twMerge(classNames('w-[136px] min-h-[250px]', className))} style={style}>
      <div className="rounded-2xl overflow-hidden w-full min-h-[150px] skeleton bg-surface-200-bg relative">
        <div className="w-full h-full default-img pt-[100%]"></div>
      </div>
      <div className="h-5 mt-[5px]  bg-surface-200-bg skeleton mx-2.5 mb-1.5"></div>
      <div className="h-5 mt-[5px]  bg-surface-200-bg skeleton mx-2.5 mb-1.5 w-1/2"></div>
      <div className="h-5 mt-[5px]  bg-surface-200-bg skeleton mx-2.5 mb-1.5 w-3/4 rounded-700"></div>
    </div>
  );
};

export default ProductCardSkeleton;
